import React from 'react';
import BasePipelineStepComponent from '../base_pipeline_step';

export default class HideColumnStepComponent extends BasePipelineStepComponent {
    async onChange(ev) {
        await super.onChange(ev);
        super.onSave(ev);
    }

    getIcon() {
        return 'transformations-hide';
    }

    canEdit() {
        return false;
    }

    renderHeader() {
        const {step} = this.props;
        return (
            <div className="pipeline-step-text pipeline-highlight">
                Hid column <span className="column-highlight">{step.column.title_name}</span>
            </div>
        );
    }

    renderValue() {
        const {step} = this.props;
        return (
            <div className="pipeline-step-text pipeline-highlight">
                Hid column <span className="column-highlight">{step.column.title_name}</span>
            </div>
        );
    }
}
